import $ from 'jquery';

/* Hide header on scroll

- The function is used for hidding the header when the user is scrolling down.
- The header should be showen again on scroll up.

- How to use:

css:
.header {
  position: fixed;
  top: 0;
  transition: top 0.2s ease-in-out;
}

.header--up {
  top: -$header-height;
}

html:
<div class="header header--down">

- Read more:
https://medium.com/@mariusc23/hide-header-on-scroll-down-show-on-scroll-up-67bbaae9a78c

*/

Drupal.behaviors.troaxHeaderScroll = {
  attach() {
    $(window).once('troaxHeaderScroll')
      .each(element => this.headerScroll(element));
  },

  headerScroll() {
    let didScroll;
    let lastScrollTop = 0;
    const delta = 5;
    const navbarHeight = $('header').outerHeight();
    const megaMenu = $('.mega-menu');

    $(window).scroll(() => {
      didScroll = true;
      localStorage.setItem('mega-menu', 'closed');
    });

    function hasScrolled() {
      const scrollTop = $(window).scrollTop();

      // Make sure they scroll more than delta
      if (Math.abs(lastScrollTop - scrollTop) <= delta) {
        return;
      }

      // If they scrolled down and are past the navbar, add class .nav-up.
      // This is necessary so you never see what is "behind" the navbar.

      if (!megaMenu.hasClass('mega-menu--open')) {
        if (scrollTop > lastScrollTop && scrollTop > navbarHeight) {
          // Scroll Down
          $('header').removeClass('header--down').addClass('header--up');
        } else if (scrollTop + $(window).height() < $(document).height()) {
          $('header').removeClass('header--up').addClass('header--down');
        }
      }

      lastScrollTop = scrollTop;
    }

    setInterval(() => {
      if (didScroll) {
        hasScrolled();
        didScroll = false;
      }
    }, 250);
  },
};
